import React, { useEffect, useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';

const AddPredefinedMessageTour = ({ forceStart, onTourEnd }) => {
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (forceStart) {
      setRun(false);
    }

    const seenTour = localStorage.getItem('tour_seen_add_predefined');

    if (!forceStart && seenTour) return;

    const timer = setTimeout(() => {
      setSteps([
        {
          target: '.tour-modal-keyword',
          content: 'Type the shortcut keyword here (e.g., "hello" or "intake"). This is the quick-text you will type in the chat to trigger the full message.',
          placement: 'bottom',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-modal-desc',
          content: 'Enter the full message description here. This is the actual text that will be sent to the patient.',
          placement: 'bottom',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-modal-links',
          content: 'Need to send a link? Click the plus icon to attach one or more URLs to this predefined message.',
          placement: 'top',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-modal-file',
          content: 'You can also attach standard files or documents (like intake PDFs) that will automatically send with this message.',
          placement: 'top',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-modal-actions',
          content: 'When you are done, click Submit to save. Note: To see the tour for the main page, simply cancel out of this window and click the Help button again.',
          placement: 'top',
          disableBeacon: true,
          disableScrolling: true
        }
      ]);
      
      setRun(true);
    }, 400); 

    return () => clearTimeout(timer);
  }, [forceStart]);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
      if (onTourEnd) onTourEnd();
      localStorage.setItem('tour_seen_add_predefined', 'true');
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      hideCloseButton={true}
      callback={handleJoyrideCallback}
      styles={{
        options: { primaryColor: '#000000', textColor: '#000000', zIndex: 10000 }, 
        tooltip: { borderRadius: '8px', padding: '20px' },
        buttonNext: { backgroundColor: '#3c8138', borderRadius: '4px' },
        buttonBack: { color: '#3c8138' }
      }}
    />
  );
};

export default AddPredefinedMessageTour;